require('./../Css/style.css');

function initNotificationPanel() {

}

export default initNotificationPanel;


// WEBPACK FOOTER //
// ./Core/Panels/NotificationPanel/Js/index.js